<template>
   <section class="bottom-bar">
        <p class="bottom-bar-txt">
            Copyright &copy; 2026 All Rights Reserved By
            <a href="https://www.tsehaybank.com.et/" style="color: rgba(240, 206, 13, 0.937)" target="_blank" rel="noopener">Tsehay bank S.C.</a>
        </p>
   </section>

</template>
<script>
  export default {}

</script>
<style>
  .bottom-bar {
    border-top: 1px solid #e7e7e7;
    position: relative;
    width: 100%;
    padding: 5px;
    margin-top: 0;
    text-align: center;
    z-index: 1000;
  }
  .bottom-bar {
      background-color: #FFFFFF;
  }

@media (min-width: 992px){
  .bottom-bar {
      height: 60px;
  }
  .bottom-bar {
      background-color: #FFFFFF;
  }
}
.bottom-bar{
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 5px;
}
.bottom-bar-txt{
    color: rgb(37, 91, 48);
    font-weight: 600;
    text-align: center;
    font-size: 12px;
}
@media (max-width: 558px){
  .bottom-bar {
      position: relative;
      margin-top: 0;
  }
}

</style>
